@if (banner) {
  <div *ngIf="banner && !bannerState?.hidden" class="subscription-banner-component d-flex justify-content-center p-2">
    <i
      class="fa fa-times p-2 pointer"
      (click)="closeBanner()"
      *ngIf="isCloseBannerVisible"
      (keydown.enter)="closeBanner()"></i>

    @if (banner === 'SCHEDULED_MAINTENANCE' && scheduledMaintenance) {
      <span class="_0">
        @if (authUser?.username) {
          {{
            'banner_maintenance_message'
              | translate
                : {
                    start: scheduledMaintenance?.startTime | mtmDateTime,
                    end: scheduledMaintenance?.endTime | mtmDateTime,
                    timezone: scheduledMaintenance?.timezone,
                  }
          }}
        }
        @if (!authUser?.username) {
          {{
            'banner_maintenance_message'
              | translate
                : {
                    start: scheduledMaintenance?.startTime | date: 'd MMMM yyyy hh:mm a',
                    end: scheduledMaintenance?.endTime | date: 'd MMMM yyyy hh:mm a',
                    timezone: scheduledMaintenance?.timezone,
                  }
          }}
        }
        @if (messageLines.length) {
          <span class="d-block pb-2" *ngFor="let line of messageLines">{{ line }}</span>
        }
      </span>
    }
  </div>
}
